import React from "react";
import "../styles/news.css";
import { useHistory, useLocation } from "react-router-dom";
import closeIcon from "../img/close-window-32.ico";

function FullNews() {
  let data = useLocation();
  const history = useHistory();

  const handleCloseFullNews = () => {
    history.push("/");
  };

  return (
    <div className="news fnews">
      <div className="borders fullNews">
        <div className="news__container ">
          <div className="news__item">
            <img
              src={closeIcon}
              alt="close"
              srcset=""
              className="closeIcon"
              onClick={handleCloseFullNews}
            />
            <div className="news__itemContainer fnews__itemContainer">
              <img
                className="fullNews__img"
                src={`${data.state.item.img}`}
                alt="fullNewsImg"
              />
              <div className="news__itemHeader">
                <h5 className="news__itemTitlle f_title">
                  {data.state.item.title}
                </h5>
                <span className="news__itemDate f_title">
                  {data.state.item.date}
                </span>
              </div>
              <p className="news__itemNews">{data.state.item.news}</p>
            </div>
          </div>
        </div>
        <div className="topLeftBorder">
          <div>
            <div className="borderTop"></div>
            <div className="borderLeft"></div>
          </div>
        </div>
        <div className="bottomRigtBorder">
          <div>
            <div className="borderRight"></div>
            <div className="borderBottom"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FullNews;
